module.exports = __webpack_public_path__ + "static/media/team.10cff7b3.svg";